module.exports = __webpack_public_path__ + "img/arrow down.93c19574.svg";